import { useState } from 'react';
import { trpc } from '../../../utils/trpc/trpc.ts';
import { CustomerDialog } from './customerDialog.tsx';
import { CustomersTable } from './customersTable.tsx';


export function Customers() {
    const [isCustomerDialogOpen, setIsCustomerDialogOpen] = useState(false);

    const { data: customers, isLoading, error, refetch } = trpc.customers.get.useQuery();
    const customerSetActive = trpc.customers.setActive.useMutation({
        onSuccess: () => refetch(),
    });

    const customersSorted = customers?.sort((a, b) => a.name.localeCompare(b.name));


    return (<>
        <div>
            <h2>Customers</h2>
            <button
                onClick={() => setIsCustomerDialogOpen(true)}
                children='Add customer'
            />
            {isLoading && <div>Loading...</div>}
            {error && <div>Error retrieving data</div>}
            {customersSorted && <CustomersTable
                style={{ width: '600px' }}
                customers={customersSorted}
                onIsActiveChange={(name: string, isActive: boolean) => customerSetActive.mutate({ name, isActive })}
            />}
        </div>

        {(isCustomerDialogOpen && customersSorted) && <CustomerDialog
            customers={customersSorted}
            onCustomerAdded={() => refetch()}
            onClose={() => setIsCustomerDialogOpen(false)}
        />}
    </>)
}
